import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { phrasesSelectorCloseEditor } from '../../actions/phrases-selector';
import {
    PhrasesSelectorModal,
    PhrasesSelectorModalProps
} from '../../components/PhrasesSelector/PhrasesSelectorModal/PhrasesSelectorModal';
import {
    selectPhrasesSelectorHintItems,
    selectPhrasesSelectorMinusPhrasesEnabled,
    selectPhrasesSelectorWizard
} from '../../selectors/phrasesSelector/phrasesSelector';
import { PhrasesSelectorWizardId } from '../../typings/phrases';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

export interface OwnProps {
    wizardId: PhrasesSelectorWizardId;
    isMinusPhrasesEnabled: boolean;
    onSubmit: () => void;
}

export type StateProps = TStateProps<PhrasesSelectorModalProps, OwnProps>;

export type DispatchProps = TDispatchProps<PhrasesSelectorModalProps, OwnProps>;

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
    const {
        isOpen,
        isLoading,
        groupInfo: { id }
    } = selectPhrasesSelectorWizard(state, ownProps.wizardId);
    const hintItems = selectPhrasesSelectorHintItems(state, ownProps.wizardId);
    const areMinusPhrasesEnabled = selectPhrasesSelectorMinusPhrasesEnabled(state, ownProps.wizardId);
    const { tld } = state.commonData;

    return {
        isOpen,
        isLoading,
        groupId: id,
        hintItems,
        areMinusPhrasesEnabled,
        tld
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>, ownProps: OwnProps): DispatchProps => {
    return {
        onClose() {
            dispatch(phrasesSelectorCloseEditor(ownProps.wizardId));
        }
    };
};

export const PhrasesSelectorModalContainer = connect<StateProps, DispatchProps, OwnProps>(
    mapStateToProps,
    mapDispatchToProps
)(PhrasesSelectorModal);
